//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Event = require('./Event')
const ObjectFunc = require('../util/ObjectFunc')

/**
 * The Event Dispatcher works as the basic event mechanism.
 * @class org.bn.msf.event.EventDispatcher
 */
const tbs_event_EventDispatcher = function() {
    /** The listeners object for all type of listeners. */
    this._listeners = {};
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_event_EventDispatcher.prototype = {
    /**
     * @constructor
     */
    constructor: tbs_event_EventDispatcher,
    
    /**
     * Add the event listener.
     * @method addEventListener
     * @param type		The event type for the listener.
     * @param listener	The listener for the registered event type.
     */
    addEventListener: function(type, listener) {
        // allocate the object if none
        if (this._listeners[type] === undefined) {
            this._listeners[type] = [];
        }
        
        if (this._listeners[type].indexOf(listener) === -1)	{
            // register the event type with the corresponding listener
            this._listeners[type].push(listener);
        }
    },
    
    /**
     * Has the event listener.
     * @method hasEventListener
     * @param type		The event type for the listener.
     * @param listener	The listener for the registered event type.
     */
    hasEventListener: function(type, listener) {
        if (type && listener) {
            // if type and listener existed, validate the event listener
            if (this._listeners[type] !== undefined && this._listeners[type].indexOf(listener) !== -1) {
                return true;
            }
        }
        else if (type && !listener) {
            // if type only, validate the any of event listener
            if (!ObjectFunc.isEmpty(this._listeners[type])) {
                return true;
            }
        }
        return false;
    },
    
    /**
     * Do dispatch the event object.
     * @method doDispatchEvent
     * @param event		The event object dispatched. It allows the simple event which is string value. The method would generate 
     * 					the event object according to the string value as the type. It points to the owner for the event target
     * 					if there is no target pointed.
     * 					It throws the error if missing the type property for the event object.
     */
    doDispatchEvent: function(event) {
        // simple event condition as the string event type
        // allow to pass the string as the event type
        if (typeof event == "string") {
            // re-alloc the event instance for the given event type
            event = new Event(event);
        }
        
        // refer the event target
        // allow to point the event target manually
        if (!event.target) {
            event.target = this;
        }

        // event type condition
        if (!event.type) {  
            throw new Error("The type property is required for the event object.");
        }

        // trigger the listeners registered on the corresponding event type
        if (this._listeners[event.type] instanceof Array) {
            var originalListeners = this._listeners[event.type];
            var listeners = originalListeners;

            // assume the event instance and 
            // validate the event.reversePropagation flag
            if (event.isEvent && event.reversePropagation()) {
                // reverse the listeners for upcoming trigger
                listeners = [];
                for (var m = originalListeners.length - 1; m > -1; m--) {
                    listeners.push(originalListeners[m]);
                }
            }

            for (var i = 0, len = listeners.length; i < len; i++) {
                // console.log("loop event listeners", event.type, i);
                // listeners[i].call(this, event);
                // @thinking If remove the listener while looping, add the condition and clear after loop
                if (listeners[i]) {
                    // @thinking Refer the event handler
                    if (!event.handler) {
                        // pass the handler reference by itself for remove usage
                        event.handler = listeners[i];
                    }
                    listeners[i].call(this, event);
                }
                // assume the event instance and 
                // check the event status whether available or not
                if (event.isEvent && !event.checkAvail()) {
                    // if not available, stop propagation for this loop
                    // console.log("event is not available", event.type);
                    break;
                }
            }

            // @thinking Clear the removed listeners after loop
            this.clearEventListeners(event.type);
        }
    },
    /**
     * Dispatch the event object.
     * @method dispatchEvent
     * @param event  The event object dispatched.
     * @param async  The async flag for the event dispatcher.
     */
    dispatchEvent: function(event, async) {
        if (!async) {
            // do the dispatch event synchronously
            this.doDispatchEvent(event);
        }
        else {
            // do the dispatch event asynchronously
            // wait for 0 ms as the next tick
            setTimeout(this.doDispatchEvent.bind(this), 0, event);
        }
    },
    
    /**
     * Remove the event listener.
     * @method removeEventListener
     * @param type		The event type for the listener.
     * @param listener	The listener for the registered event type.
     */
    removeEventListener: function(type, listener) {
        if (!this.hasEventListener(type, listener))  return;

        var index = this._listeners[type].indexOf(listener);
        
        // whether it exists the listener
        if (index !== -1) {
            // remove the listener
            // this._listeners[type].splice(index, 1);
            // @thinking Consider to remove the listener within the dispatch event loop
            // @thinking Donot remove the item now, just change the value as null
            // @thinking Remove it actually after loop
            this._listeners[type][index] = null;
        }
    },
    /**
     * Remove the event listeners by event type.
     * @method removeEventListeners
     * @param type		The event type for the listener.
     */
    removeEventListeners: function(type) {
        if (this._listeners[type] !== undefined) {
            this._listeners[type] = null;
            delete this._listeners[type];
        }
    },

    /**
     * Clear the event listeners.
     * @private clearEventListeners
     * @thinking Clear the event listeners from the given type with the null value.
     * @param type		The event type for the listener.
     */
    clearEventListeners: function(type) {
        var listeners = this._listeners[type];
        if (listeners !== undefined) {
            // use the len as the max round for the remove
            var len = listeners.length;
            // loop for the max round number
            for (var i = 0; i < len; i++) {
                // find the null value listener
                var index = listeners.indexOf(null);
                if (index > -1) {
                    // if existed, remove it and continue
                    listeners.splice(index, 1);
                }
                else {
                    // if not existed, return
                    return;
                }
            }
        }
    }
}

module.exports = tbs_event_EventDispatcher